import { render, staticRenderFns } from "./CardWeeks.vue?vue&type=template&id=2127316c"
import script from "./CardWeeks.vue?vue&type=script&lang=js"
export * from "./CardWeeks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports